import * as React from 'react';
import Box from '@mui/material/Box';
import { keyframes } from '@mui/material/styles';
import { brand } from '../../shared-theme/brand';

// ratio = intrinsic width/height, so each slot can reserve its exact width
// up front — a late-loading image must not change the track width, or the
// animation (a % of that width) visibly jumps.
const customers = [
  { src: '/customers/schmidt-national.png', alt: 'Schmidt National Law Group', height: { xs: 30, sm: 36 }, ratio: 524 / 96 },
  { src: '/customers/lju.png', alt: 'The LJU Law Firm', height: { xs: 32, sm: 38 }, ratio: 330 / 96 },
  { src: '/customers/lorre-sylvan-smith.png', alt: 'Lorre Sylvan Smith', height: { xs: 44, sm: 52 }, ratio: 1 },
  { src: '/customers/vincent-caputo.png', alt: 'Law Office of Vincent J. Caputo', height: { xs: 32, sm: 38 }, ratio: 418 / 96 },
  { src: '/customers/adam-burke.png', alt: 'Attorney Adam Burke', height: { xs: 30, sm: 36 }, ratio: 415 / 96 },
  { src: '/customers/brian-j-levy.png', alt: 'Brian J. Levy & Associates', height: { xs: 32, sm: 38 }, ratio: 376 / 96 },
  { src: '/customers/leach-firm.png', alt: 'The Leach Firm', height: { xs: 36, sm: 44 }, ratio: 260 / 96 },
  { src: '/customers/chuck-buchan.png', alt: 'Chuck Buchan, Attorney at Law', height: { xs: 30, sm: 36 }, ratio: 397 / 96 },
  { src: '/customers/virginia-employment-law.png', alt: 'Virginia Employment Law', height: { xs: 32, sm: 38 }, ratio: 369 / 96 },
  { src: '/customers/patricia-pastor.png', alt: 'Law Office of Patricia M. Pastor, PLLC', height: { xs: 44, sm: 54 }, ratio: 222 / 96 },
  { src: '/customers/jones-trial.png', alt: 'Jones Trial Attorneys', height: { xs: 30, sm: 36 }, ratio: 519 / 96 },
];

// With few customers a single set is narrower than the viewport, so the
// row is repeated REPS times and the animation shifts by exactly one set
// (100/REPS %) — the wrap point lands on an identical frame and is invisible.
const REPS = 4;

const scroll = keyframes`
  from { transform: translate3d(0, 0, 0); }
  to { transform: translate3d(-${100 / REPS}%, 0, 0); }
`;

// Continuously scrolling ticker of the firms already running on OpenIntake.
export default function CustomerLogos() {
  return (
    <Box
      sx={{
        py: { xs: 3.5, sm: 4.5 },
        borderTop: `1px solid ${brand.sand}`,
        borderBottom: `1px solid ${brand.sand}`,
      }}
    >
      <Box
        sx={{
          overflow: 'hidden',
          maskImage: 'linear-gradient(to right, transparent, black 12%, black 88%, transparent)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: 'max-content',
            animation: `${scroll} 40s linear infinite`,
            '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
          }}
        >
          {Array.from({ length: REPS }, () => customers).flat().map((logo, i) => (
            <Box
              key={`${logo.alt}-${i}`}
              component="img"
              src={logo.src}
              alt={logo.alt}
              aria-hidden={i >= customers.length}
              sx={{
                height: logo.height,
                width: {
                  xs: Math.round(logo.height.xs * logo.ratio),
                  sm: Math.round(logo.height.sm * logo.ratio),
                },
                objectFit: 'contain',
                flexShrink: 0,
                mx: { xs: 5, sm: 10 },
                opacity: 0.65,
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
